import type Dialog from '@naturehouse/design-system/components/molecules/dialog/Dialog';
import { getCurrentMonthNumber, getCurrentYear } from '../../../util/dateHelper';
import CalendarBase from './CalendarBase';
import type Month from './month/Month';

export default class CalendarComponent extends CalendarBase {
    constructor() {
        super();

        const currentYear: number = getCurrentYear();
        const currentMonth: number = getCurrentMonthNumber();
        this.end = new Date(currentYear + 2, currentMonth);
    }

    protected connectedCallback(): void {
        super.connectedCallback();
        this.#update();
    }

    protected handleDayClick(event: CustomEvent): void {
        const { day }: { day: HTMLElement } = event.detail;

        if (day.dataset.blocked) {
            this.#openBlockedModal();
            return;
        }

        const endpoint = this.getAttribute('endpoint') || '';
        if (!endpoint) {
            return;
        }

        const url = new URL(`${window.location.origin}${endpoint}`);
        const date = day.dataset.date;

        if (date) {
            url.searchParams.set('arrivalDate', date);
        }

        window.open(url.href, '_blank');
    }

    #openBlockedModal(): void {
        const modalElement: Dialog | null = document.getElementById(
            'calendar-not-allowed-modal'
        ) as Dialog;

        if (modalElement === null) {
            return;
        }

        modalElement.showModal();
    }

    #update(): void {
        const blocked = this.getAttribute('blockedperiods') || '[]';
        this.months.forEach((month: Month): void => {
            month.blocked = JSON.parse(blocked);
        });
    }
}

if (!customElements.get('calendar-component')) {
    customElements.define('calendar-component', CalendarComponent);
}
